// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as ReactModal from "react-modal";
import * as AbModificationForm from "./ab-modification/AbModificationForm.bs.js";
import * as SelectModificationView from "./SelectModificationView.bs.js";
import * as SimpleModificationForm from "./simple-modification/SimpleModificationForm.bs.js";
import * as PricingDashboardAssetsManager from "../../../../assets/PricingDashboardAssetsManager.bs.js";
import * as CloseCreateModificationConfirmationModal from "./common/CloseCreateModificationConfirmationModal.bs.js";

var modal_close_cross = PricingDashboardAssetsManager.getImage("modal-close.svg");

function CreateModificationModal(Props) {
  var close_modal = Props.close_modal;
  var core_pricing = Props.core_pricing;
  var match = React.useState(function () {
        return /* SelectModification */0;
      });
  var update_modal_state = match[1];
  var match$1 = React.useState(function () {
        return false;
      });
  var toggleConfirmationModal = match$1[1];
  var tmp;
  switch (match[0]) {
    case /* SelectModification */0 :
        tmp = React.createElement(SelectModificationView.make, {
              onNext: (function (s) {
                  return Curry._1(update_modal_state, (function (param) {
                                return s;
                              }));
                })
            });
        break;
    case /* ABForm */1 :
        tmp = React.createElement(AbModificationForm.make, {
              core_pricing: core_pricing,
              close_modal: close_modal,
              openConfirmationModal: (function (param) {
                  return Curry._1(toggleConfirmationModal, (function (param) {
                                return true;
                              }));
                })
            });
        break;
    case /* SimpleForm */2 :
        tmp = React.createElement(SimpleModificationForm.make, {
              core_pricing: core_pricing,
              close_modal: close_modal,
              openConfirmationModal: (function (param) {
                  return Curry._1(toggleConfirmationModal, (function (param) {
                                return true;
                              }));
                })
            });
        break;
    
  }
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  
                }),
              overlayClassName: "modal-overlay create-modification-modal-overlay",
              className: "modal-content create-modification-modal-content",
              ariaHideApp: false,
              shouldCloseOnOverlayClick: false,
              children: null
            }, React.createElement("div", {
                  className: "c-create-modification-modal"
                }, React.createElement("div", {
                      className: "title-bar"
                    }, React.createElement("div", {
                          className: "title"
                        }, "Create Modification"), React.createElement("div", {
                          className: "close-btn",
                          onClick: (function (param) {
                              return Curry._1(toggleConfirmationModal, (function (param) {
                                            return true;
                                          }));
                            })
                        }, React.createElement("img", {
                              src: modal_close_cross
                            }))), tmp), React.createElement(CloseCreateModificationConfirmationModal.make, {
                  isOpen: match$1[0],
                  onConfirmCb: (function (param) {
                      Curry._1(toggleConfirmationModal, (function (param) {
                              return false;
                            }));
                      return Curry._1(close_modal, undefined);
                    }),
                  onCancelCb: (function (param) {
                      return Curry._1(toggleConfirmationModal, (function (param) {
                                    return false;
                                  }));
                    })
                }));
}

var make = CreateModificationModal;

export {
  modal_close_cross ,
  make ,
  
}
/* modal_close_cross Not a pure module */
